import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../utils/postData";

export const addMilestone = createAsyncThunk(
  "initiatives/addMilestone",
  async ({ initiativeId, data }, { rejectWithValue }) => {
    try {
      const response = await postData(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/${initiativeId}/milestones`,
        data
      );
      if (!response || !response.success) {
        return rejectWithValue(response?.message || "Failed to add milestone");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to add milestone");
    }
  }
);
